// This project has no tsconfig.json, so this reference is needed to pull in
// react-app-env.d.ts's ambient declarations (react-scripts types, *.css
// wildcard module) — an unimported .d.ts otherwise isn't part of this file's
// inferred TS project.
/// <reference path="../../../../react-app-env.d.ts" />
import React, { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import '../styles/public-layout.css';
import { getPublicRestauranteReservo } from '../../../../services/publicReservoApi';

const PublicLayout: React.FC<{ children?: React.ReactNode; title?: string }> = ({ children, title }) => {
  const { slug_restaurante } = useParams<{ slug_restaurante: string }>();
  const [restaurantName, setRestaurantName] = useState<string>('Reservas do Restaurante');

  useEffect(() => {
    const fetchRestaurant = async () => {
      if (!slug_restaurante) return;

      try {
        const restaurant = await getPublicRestauranteReservo(slug_restaurante);
        if (restaurant?.nome) {
          setRestaurantName(restaurant.nome);
        }
      } catch (error) {
        console.error('Erro ao buscar restaurante:', error);
      }
    };

    fetchRestaurant();
  }, [slug_restaurante]);

  return (
    <div className="public-layout">
      <header className="public-header">
        <div className="logo">
          <h1>{title || restaurantName}</h1>
        </div>
      </header>
      <main className="public-content">
        {children || <Outlet />}
      </main>
      <footer className="public-footer">
        <p>© {new Date().getFullYear()} Reservo</p>
      </footer>
    </div>
  );
};

export default PublicLayout;
